export const INITIAL_STATE = { };

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_DATA_ARRIVED/PORTFOLIO_HEALTH":
            const payload = action.payload;
            return { ...state, ...payload, failure: null };
        case "SUBSCRIPTION_DATA_FAILED/PORTFOLIO_HEALTH":
            return { ...state, failure: action.payload };
        default:
            return state;
    }
}

export default dispatch => ({
});
